import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Loading = () => (
  <div className="flex min-h-screen items-center justify-center pt-16">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-black/20 border-t-black" />
  </div>
);

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to={`/login?redirect=${location.pathname}`} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== "admin") return <Navigate to="/admin/login?denied=1" replace />;
  return children;
}
